/**
 * Comment Event Listener Setup
 * Pure event listener registration separated from handler logic
 */

import { disposeEventScope, getEventScope } from "../core/event-scope/event-scope";

type CommentEventHandler = (event: Event) => void | Promise<void>;

interface CommentListenerHandler {
    submitHandler?: CommentEventHandler;
    deleteHandler?: CommentEventHandler;
    replyToggleHandler?: CommentEventHandler;
    dropdownHandler?: CommentEventHandler;
    editHandler?: CommentEventHandler;
    cancelEditHandler?: CommentEventHandler;
}

class CommentListener {
    /**
     * Setup all event listeners with provided handler
     */
    public static setup(handler: CommentListenerHandler): void {
        // Dispose existing listeners first (prevents double-binding)
        disposeEventScope(document, "comment");

        const scope = getEventScope(document, "comment");

        // Comment form submission - use capture phase
        if (handler.submitHandler) {
            scope.on("submit", handler.submitHandler, { capture: true });
        }

        // All click-based handlers
        if (handler.deleteHandler) {
            scope.on("click", handler.deleteHandler);
        }
        if (handler.replyToggleHandler) {
            scope.on("click", handler.replyToggleHandler);
        }
        if (handler.dropdownHandler) {
            scope.on("click", handler.dropdownHandler);
        }
        if (handler.editHandler) {
            scope.on("click", handler.editHandler);
        }
        if (handler.cancelEditHandler) {
            scope.on("click", handler.cancelEditHandler);
        }
    }

    /**
     * Remove all event listeners
     */
    public static cleanup(handler: CommentListenerHandler): void {
        void handler;
        disposeEventScope(document, "comment");
    }
}

export { CommentListener };
